/* Product-page INP reporter. Reports the final INP of each page view to
   Microsoft Clarity as bucketed custom tags. See
   docs/superpowers/specs/2026-09-16-mobile-inp-bfcm-design.md
   Clarity tag values are strings, so numeric values are bucketed into bands. */
(function () {
  'use strict';

  if (!window.webVitals || typeof window.webVitals.onINP !== 'function') return;

  var BANDS = [100, 200, 300, 500, 1000];
  var LABELS = ['0-100', '100-200', '200-300', '300-500', '500-1000', '1000+'];

  function bucket(value) {
    for (var i = 0; i < BANDS.length; i++) {
      if (value < BANDS[i]) return LABELS[i];
    }
    return LABELS[LABELS.length - 1];
  }

  function dominantPhase(attribution) {
    var phases = [
      ['input', attribution.inputDelay || 0],
      ['processing', attribution.processingDuration || 0],
      ['presentation', attribution.presentationDelay || 0]
    ];
    phases.sort(function (a, b) { return b[1] - a[1]; });
    return phases[0][0];
  }

  function target(attribution) {
    var raw = attribution.interactionTarget || 'unknown';
    return String(raw).slice(0, 120);
  }

  function formFactor() {
    return window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
  }

  function send(tags) {
    if (typeof window.clarity !== 'function') return false;
    for (var key in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, key)) {
        window.clarity('set', key, tags[key]);
      }
    }
    return true;
  }

  window.webVitals.onINP(function (metric) {
    var a = metric.attribution || {};
    var band = bucket(metric.value);

    var tags = {
      inp_bucket: band,
      inp_target: target(a),
      inp_phase: dominantPhase(a),
      inp_tpl: window.__inpTemplate || 'unknown',
      inp_ff: formFactor()
    };

    /* Written on every INP change rather than once at page unload.
       reportAllChanges is true for a specific reason: with it false, web-vitals
       reports at pagehide or visibilitychange, so the tag would be written as the
       page is being torn down. Clarity batches its uploads, so that write may never
       transmit, and any retry timer would never fire. The sessions lost that way are
       the ones that tap and navigate away fastest, which are the slow-INP sessions
       this instrument exists to find. Losing them would bias the data toward looking
       healthier than reality.

       Each write overwrites the previous one, so the final tag always reflects the
       most recent INP value. If Clarity is not ready yet, skip silently: the next
       INP change writes again, which is a better retry than a timer. */
    if (send(tags) && metric.value >= 200) {
      /* Prioritize retention of slow sessions so the interaction can be watched. */
      window.clarity('upgrade', 'slow_inp');
    }

    window.__inpRumLastValue = metric.value;
  }, { reportAllChanges: true });

  window.__inpRumLoaded = true;
})();